import * as types from '../constants/Action_types'

const initialState = {
    archived: [],

}

export default function (state = initialState, action) {

    switch (action.type) {

        case types.GET_USERS:


            return {
                ...state,
                archived: action.payload
            }

        default:
            return state
    }
}